import {TFunction} from 'i18next'

export const UnloadingMethodStringKeys = {
  '1': 'unloadingMethod.stationaryCustomer',
  '2': 'unloadingMethod.siteSilo',
  '3': 'unloadingMethod.siteSpreader',
  '4': 'unloadingMethod.foilTube',
  '5': 'unloadingMethod.canonDischarge',
  '6': 'unloadingMethod.opencastMining',
  '7': 'unloadingMethod.individualValue',
  '8': 'unloadingMethod.riser',
  '9': 'unloadingMethod.buildingChemestry',
  A: 'unloadingMethod.tipping',
  B: 'unloadingMethod.bucket',
  C: 'unloadingMethod.continuousDischarge',
  D: 'unloadingMethod.craneSmallBucket',
  E: 'unloadingMethod.thirdPartyPump',
  F: 'unloadingMethod.converabelt',
  G: 'unloadingMethod.wheelLoader',
  H: 'unloadingMethod.fundationPile',
  I: 'unloadingMethod.screedPump',
  J: 'unloadingMethod.curbstone',
  K: 'unloadingMethod.crane',
  L: 'unloadingMethod.hydraulicChute',
  M: 'unloadingMethod.pumi',
  N: 'unloadingMethod.helicopterDelivery',
  O: 'unloadingMethod.ownContractedPump',
  P: 'unloadingMethod.customerPump',
  Q: 'unloadingMethod.pumpOnly',
  R: 'unloadingMethod.pipe',
  S: 'unloadingMethod.stamix',
  T: 'unloadingMethod.pipePump',
  U: 'unloadingMethod.unknown',
  V: 'unloadingMethod.paver',
  W: 'unloadingMethod.wheelbarrow',
  X: 'unloadingMethod.converabelt'
}

export const getUnloadingMethodText = (
  t: TFunction,
  unloadingMethod: string | undefined
): string | undefined => {
  const unloadingMethodCode = unloadingMethod?.toLocaleUpperCase()

  if (unloadingMethodCode) {
    // if it's not a single character code return raw value
    if (unloadingMethodCode.length > 1) {
      return unloadingMethodCode
    }
    const methodStringKey = UnloadingMethodStringKeys[unloadingMethodCode]
    return methodStringKey ? t(methodStringKey) : t('unloadingMethod.unknown')
  }

  return undefined
}
